import { ComponentPropsWithRef } from "react";

export const InfoIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1 37.6483C15.1 36.3495 16.1529 35.2966 17.4517 35.2966H30.554C31.8528 35.2966 32.9057 36.3495 32.9057 37.6483C32.9057 38.9471 31.8528 40 30.554 40H17.4517C16.1529 40 15.1 38.9471 15.1 37.6483Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2839 22.3623C17.2839 21.0635 18.3368 20.0106 19.6356 20.0106H24.0031C25.3019 20.0106 26.3548 21.0635 26.3548 22.3623V37.6483C26.3548 38.9471 25.3019 40 24.0031 40C22.7043 40 21.6514 38.9471 21.6514 37.6483V24.714H19.6356C18.3368 24.714 17.2839 23.6611 17.2839 22.3623Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.0865 11.4436C26.2579 11.1173 26.3548 10.7458 26.3548 10.3517C26.3548 9.05289 25.3019 8 24.0031 8C22.1013 8 20.5596 9.54174 20.5596 11.4436C20.5596 13.3454 22.1013 14.8871 24.0031 14.8871C25.3019 14.8871 26.3548 13.8342 26.3548 12.5354C26.3548 12.1413 26.2579 11.7698 26.0865 11.4436Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6516 10.3517C21.6516 9.05289 22.7045 8 24.0033 8C25.9051 8 27.4469 9.54174 27.4469 11.4436C27.4469 13.3454 25.9051 14.8871 24.0033 14.8871C22.7045 14.8871 21.6516 13.8342 21.6516 12.5354C21.6516 12.1413 21.7486 11.7698 21.9199 11.4436C21.7486 11.1173 21.6516 10.7458 21.6516 10.3517Z"
      fill="currentColor"
    />
  </svg>
);
